module.exports = __webpack_public_path__ + "static/media/bdayIcon.4eef2ce5.png";